import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';
import { CreditsFunnels } from 'helpers/funnels/funnels';

export const useCreditsAnalytics = () => {
  const trackCreditReplenishChecked = (payload: {
    status: 'on' | 'off';
    creditFunnel?: CreditsFunnels;
  }) => {
    TrackingApi.trackClick({
      info: 'credits_refill',
      parameter: payload.status,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackVerticaCreditWelcomeGift = (payload: {
    cost?: number;
    operation: 'show' | 'click' | 'close';
  }) => {
    const DEFAULT_COST = 100;

    TrackingApi.trackPopup({
      info: `credits_welcome_gift_${payload.cost || DEFAULT_COST}`,
      operation: payload.operation,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackVerticaCreditWelcomeGiftRetention = (payload: {
    cost?: number;
    operation: 'show' | 'click' | 'close';
  }) => {
    const DEFAULT_COST = 100;

    TrackingApi.trackPopup({
      info: `credits_welcome_gift_retention_${payload.cost || DEFAULT_COST}`,
      operation: payload.operation,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackVerticaCreditProfileUnlock = (payload: {
    profileId: number;
    cost?: number;
    operation: 'show' | 'click' | 'close';
  }) => {
    const DEFAULT_COST = 15;

    TrackingApi.trackPopup({
      info: `credits_unlock_profile_${payload.cost || DEFAULT_COST}`,
      operation: payload.operation,
      parameter: String(payload.profileId),
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackVerticaCreditsPurchaseSuccess = (payload: {
    orderId: string;
    cost: number;
    operation: 'show' | 'click' | 'close';
  }) => {
    TrackingApi.trackPopup({
      info: `credits_purchase_success_${payload.cost}`,
      operation: payload.operation,
      parameter: payload.orderId,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackVerticaCreditsPurchaseFail = (payload: {
    orderId: string;
    operation: 'show' | 'click' | 'close';
  }) => {
    TrackingApi.trackPopup({
      info: 'credits_purchase_changecard',
      operation: payload.operation,
      parameter: payload.orderId,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackVerticaCreditsMessageInfo = useCallback(
    (payload: { operation: 'show' | 'click' | 'close' }) => {
      TrackingApi.trackPopup({
        info: 'credits_message_info',
        operation: payload.operation,
        screen: getScreenOrientationWithSizes(),
      }).catch();
    },
    []
  );

  const trackVerticaCreditsBoostBanner = useCallback(
    (payload: { operation: 'show' | 'click' | 'close' }) => {
      TrackingApi.trackPopup({
        info: 'credits_message_boost_banner',
        operation: payload.operation,
        screen: getScreenOrientationWithSizes(),
      }).catch();
    },
    []
  );

  const trackVerticaCreditsNotEnough = (payload: {
    replenish: 'on' | 'off';
    operation: 'show' | 'click' | 'close';
  }) => {
    TrackingApi.trackPopup({
      info: 'credits_not_enough',
      operation: payload.operation,
      parameter: `replenish_${payload.replenish}`,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  return {
    trackCreditReplenishChecked,

    trackVerticaCreditWelcomeGift,
    trackVerticaCreditProfileUnlock,
    trackVerticaCreditsPurchaseSuccess,
    trackVerticaCreditsPurchaseFail,
    trackVerticaCreditsMessageInfo,
    trackVerticaCreditsBoostBanner,
    trackVerticaCreditsNotEnough,
    trackVerticaCreditWelcomeGiftRetention,
  };
};
